import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const DiabetesIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path
        d="M19 1.4C16.7 1 14.4.8 12.1.8 9.7.8 7.4 1 5 1.4c-.4 0-.7.2-.7.6L5 18.5c0 .4.3.6.7.6h4.2v3.4c0 .7.5.7 1.1.7h2c.6 0 1.1 0 1.1-.7v-3.4h4.2c.4 0 .7-.2.7-.6L19.7 2c0-.4-.3-.6-.7-.6zm-7 14.2c-1.9 0-3.5-1.6-3.5-3.5.4-2.5 1.4-4.9 3-6.9.3-.3.7-.3 1 0 1.6 2 2.6 4.4 3 6.9 0 1.9-1.6 3.5-3.5 3.5z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </IconBase>
  );
};

export default DiabetesIcon;
